import { Col, Image, Row } from "react-bootstrap"
import React from "react"
import CardResearch from "./cardResearch"
import franck from "../images/franck.png"
import CV from "../pdf/CV_Oct2020Columbia_Polleux_F.pdf"

export default function ResearchDetail() {
  return (
    <>
      <div>
          <h1 className="peopleTitle">Research</h1>
          <div className="researchText">
            <div
              style={{
                textAlign: "center",
                paddingBottom: 30,
              }}
            >
              Research in the Polleux laboratory focuses on three important
              questions relevant to the brain
            </div>
            <CardResearch/>
          </div>
      </div>



      <Row className="researchText" style={{
        paddingBottom: "40px"
      }}>
        <Col xs={12} md={8} className="img">
          <p>
          Our work provides new insights into the cellular and molecular
          mechanisms underlying the establishment and maintenance of brain
          connectivity and has significant implications for our
          understanding of the pathophysiological mechanisms underlying
          socially-devastating neurodevelopmental disorders and
            neurodegenerative diseases. </p>

        </Col>
      </Row>

      <div style={{
        width: "80%",
        borderBottom: "1px solid #4E4F50",
        margin: "auto",
        marginBottom: "50px"
      }}/>

      <div>
        <h1 className="peopleTitle">About the PI</h1>
        <Row xs={1} md={1} lg={2} className="researchRow">

          <Col xs={12} md={4} className="img">
            <Image
              src={franck}
              className="researchImage"
              style={{maxHeight: "300px"}}
            />
          </Col>
          <Col xs={12} md={8} className="img">

            <div
              className="researchText"
              style={{padding: 30}}
            ><p>
              Dr. Franck Polleux did his undergraduate and graduate studies at
              Université Claude Bernard in Lyon, (France) where he obtained his
              Ph.D. in Neuroscience in 1997. He then joined the laboratory of
              Dr. Anirvan Ghosh at Johns Hopkins University for his
              post-doctoral training.
            </p><p>
              In 2002, Dr Polleux was hired as an Assistant Professor in the
              Neuroscience Center and Department of Pharmacology at the
              University of North Carolina- Chapel Hill where he became an
              Associate Professor in 2008. In August 2010, he joined The Scripps
              Research Institute in La Jolla, California. In November 2013, he
              was recruited as a Professor in the {" "}
              <a className="toolLink"
              href="https://neuroscience.columbia.edu/"
                 target="_blank"
                 rel="noopener noreferrer"
              >Department of Neuroscience</a> at
              Columbia University to join the new Mortimer B. Zuckerman Mind,
              Brain, Behavior Institute.
            </p><p>
              Throughout his career, Dr Polleux has focused on the
              identification of the molecular mechanisms underlying neuronal
              development in the mammalian brain. More recently, his lab started
              studying the genetic basis of human brain evolution as well as the
              signaling pathways underlying synaptic loss during early stages of
              Alzheimer’s Disease progression.
            </p>
              <p>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  className="toolLink"
                  style={{ margin: "15px" }}
                  href="https://www.youtube.com/watch?v=E3k8q5B3eJs&t=2597s"
                >
                  {" "}
                  Watch Franck's talk on World Wide Neuro
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  className="toolLink"
                  style={{ margin: "15px" }}
                  href={CV}
                >
                  [CV]
                </a>
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}
